// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverModelRelation, _;

  Weaver = require('./Weaver');

  _ = require('lodash');

  WeaverModelRelation = class WeaverModelRelation extends Weaver.Relation {
    _getClassName(node) {
      return node.className;
    }

    // Check if relation is allowed according to definition
    _assertCorrectClass(to) {
      var allowed, defs, found, modelKey;
      if (to instanceof Weaver.Relation.Record) {
        to = to.toNode;
      }
      if (to instanceof Weaver.ModelClass || to instanceof Weaver.DefinedNode) {
        defs = to.getDefinitions();
        modelKey = this.owner._getModelKey(this.relationKey, ...defs) || this.modelKey;
        if (modelKey != null) {
          found = this.owner.getToRanges(modelKey, to);
        }
        if ((found == null) || found.length === 0) {
          if (modelKey != null) {
            allowed = JSON.stringify(this.owner.getRanges(modelKey));
          }
          throw new Error(`Model ${this.className} is not allowed to have relation ${modelKey} to ${to.id()}\nof def ${JSON.stringify(defs)}, allowed ranges are ${allowed}`);
        }
      }
    }

    add(node, relId, addToPendingWrites = true) {
      this._assertCorrectClass(node);
      return super.add(node, relId, addToPendingWrites);
    }

    update(oldNode, newNode) {
      this._assertCorrectClass(newNode);
      return super.update(oldNode, newNode);
    }

    async load() {
      var nodes, reloadedRelation;
      nodes = (await new Weaver.ModelQuery(this.model).disableKeyMapping().restrict(this.owner).selectOut(this.key, '*').find());
      reloadedRelation = nodes[0].nodeRelation(this.key);
      this._records = reloadedRelation.allRecords();
      return reloadedRelation.all();
    }

  };

  module.exports = WeaverModelRelation;

}).call(this);
